import React from 'react'
import { Popup } from '../../../components/Popup'
import { Button } from '../../../components/Button';

export const EnumsSelector = ({closeFn, title, enums, selectedEnums, selectEnums}) => {

  return (
    <Popup closeFn={closeFn} title={`Выберите ${title}`} button={<Button text='Выбрать' onClick={closeFn}/>}>
        {enums.map(e => <div className={`enum-item ${selectedEnums.some(eId => eId === e._id) ? 'selected dark-theme-bg1' : 'dark-theme-bg0'}`} key={e._id} onClick={() => selectEnums(e._id)}>{e.name}</div>)}
    </Popup>
  )
}
